import { ExpandMoreRounded, ExpandLessRounded } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { useState } from "react";

function DimensionPeriodAccordian({ PeriodTime, children }) {
  const [open, setOpen] = useState(true);

  return (
    <Box sx={{ width: "100%", margin: "" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: "6px",
          position: "relative",
        }}
      >
        <Box
          sx={{ display: "flex", alignItems: "center", position: "relative" }}
        >
          <IconButton
            sx={{ marginRight: "0.5em" }}
            onClick={() => {
              setOpen(!open);
            }}
          >
            {!open && (
              <ExpandMoreRounded fontSize="large" sx={{ color: "black" }} />
            )}
            {open && (
              <ExpandLessRounded fontSize="large" sx={{ color: "black" }} />
            )}
          </IconButton>
          <Typography variant="h3">{PeriodTime}</Typography>
        </Box>
      </Box>
      {open && (
        <Box
          sx={{
            borderTop: 0,
            margin: "0 auto",
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  );
}

export default DimensionPeriodAccordian;
